export type { TooltipProps } from './Tooltip'
export { Tooltip } from './Tooltip'
